"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mergeConstantsFiles = _interopRequireDefault(require("./mergeConstantsFiles"));

var _prepTemplates = _interopRequireDefault(require("./prepTemplates"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Process Strings
 *
 * This is simply the orchestration func that pulls in string constants from
 * the window, merges them if necessary, and then preps them for rendering
 * on a view.
 */
var _default = function _default(cakeStrings) {
  var stringFile = cakeStrings;

  if (window && window.cakeAppThemeJSON) {
    var clientStrings = window.cakeAppThemeJSON.appStrings || {};
    stringFile = (0, _mergeConstantsFiles.default)(cakeStrings, clientStrings);
  }

  return (0, _prepTemplates.default)(stringFile);
};

exports.default = _default;